import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';

export const root = {
  [HTTP_METHODS.POST]: {
    method: HTTP_METHODS.POST,
    params: {} as { id: string },
    url: `${CENTRAL_API_V3}/customers/@customerId/rtmp/@id/stop`,
  },
};
